<template>
	<div>
        <b-modal id="modalAddToLister" 
            ref="modalAddToLister"
            size="md" 
            :title="transUF('add to lists')"
            @ok="addToList"
        >
            <Multiselect 
                v-model="selectedMailinglists"
                :options="mailinglists"
                label="name"
                track-by="id"
                :groupSelect="false"
                :close-on-select="true"
                multiple
            ></Multiselect>
        </b-modal>
	</div>
</template>

<script>
export default {
    name : 'AddToLister',
    props : [ 'addableRef', 'mailinglists' ],
    methods : {
        show(ids) {
            this.ids = ids
            this.$refs.modalAddToLister.show()
        },
        addToList() {
            var t = this
            var mailinglists = []
            for (var i = 0; i<t.selectedMailinglists.length; i++)
                mailinglists.push(t.selectedMailinglists[i].id)
            window.axios.post('/api/editorials/add-to-lists', {
                ids : t.ids,
                mailinglists : mailinglists
            }).then(function() {
                if (t.ids.length === 1)
                    window.notify('success', 'Oggetto inserito nelle liste selezionate')
                else
                    window.notify('success', 'Oggetti inseriti nelle liste selezionate')
                t.ids = []
                t.selectedMailinglists = []
                t.$parent.$refs[t.addableRef].refresh()
            })
        }
    },
    data() {
        return {
            ids : [],
            selectedMailinglists : []
        }
    }
}
</script>